import angular from 'angular';

let ProcedureListController = function (Procedure, $filter, Toast, $scope, $state) {
  let $ctrl = this;
  $ctrl.resources;
  $ctrl.$scope = $scope;

  angular.extend($ctrl, {
    show, orderList
  });

  activate();


  $scope.activeStatus = function (resource) {

    Procedure
      .save(resource)
      .then(response => {
        $ctrl.resource = response;
        let messageSuccess = $filter('translate')('procedure-list-active-success')
        Toast.success(messageSuccess);
      })
      .catch(err => {
        console.log('err:' ,  err);
        let messageError = $filter('translate')('procedure-list-active-error')
        Toast.error(messageError);
      });

  };

  function activate() {
    $ctrl.resources = {
      count: 0,
      data: []
    };

    $ctrl.uiState = 'LOADING';

    $ctrl.promise;

    $ctrl.$scope.tableConfig = {
      page: 1,
      limit: 10,
      order: 'name',
      like_search: '',
      like_search_fields: [
        'name',
        'description'
      ]
    };

    $ctrl.$scope.$watch('tableConfig', () => {
      loadData()
    }, true);
  }

  function show(id) {
    $state.go('procedure.show', {id});
  }

  function orderList(field) {
    var tableConfig = $ctrl.$scope.tableConfig;
    if (tableConfig.order) {
      var currentField = tableConfig.order.split(' ')[0];
      var currentOrder = tableConfig.order.split(' ')[1];

      if (currentField === field) {
        currentOrder = currentOrder === 'DESC' ? 'ASC' : 'DESC';
        tableConfig.order = currentField + ' ' + currentOrder;
      } else {
        tableConfig.order = field + ' ' + 'ASC';
      }
    } else {
      tableConfig.order = field + ' ' + ' ASC';
    }
  }

  // Local functions

  function loadData() {
    $ctrl.promise = Procedure
      .load($ctrl.$scope.tableConfig)
      .then(response => {
      	setPlaceHolderValues(response.data);
        $ctrl.resources = response;
        $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
        $ctrl.$scope.$apply();
      })
      .catch(err => {
        console.log('err:' ,  err);
        $ctrl.uiState = 'ERROR';
      });
  }

  function setPlaceHolderValues(arr) {
  	_.forEach(arr, item => {
  		if (item.description === null || item.description === undefined) {
  			item.description = $filter('translate')('common-not-informed');
  		}
  	});
  }
}

ProcedureListController.$inject = ['Procedure', '$filter', 'Toast', '$scope', '$state'];

export default ProcedureListController;



// WEBPACK FOOTER //
// ./client/app/components/procedure/procedure-list.controller.js